import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { StorageService } from 'src/app/service/shared/storage.service';

@Component({
  selector: 'app-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss']
})
export class StepperComponent implements OnInit {
  @Input() recebeAba!: string;

  public abaDependenteDisable: boolean = true;
  public abaListaMaterialDisable: boolean = true;
  public abaFormaEntregaDisable: boolean = true;
  public abaEnderecoEntregaDisable: boolean = true;
  public abaFormaPagamentoDisable: boolean = true;
  public abaFinalizacaoDisable: boolean = true;

  constructor(private storage: StorageService) { }

  ngOnInit(): void {
    this.habilitaStepper();
  }

  private habilitaStepper() {
    switch (this.recebeAba) {
      case 'dependentes':
        this.abaDependenteDisable = false;
        break;
      case 'listaMaterial':
        this.abaDependenteDisable = false;
        this.abaListaMaterialDisable = false;
        break;
      case 'formaEntrega':
        this.abaDependenteDisable = false;
        this.abaListaMaterialDisable = false;
        this.abaFormaEntregaDisable = false;
        break;
      case 'enderecoEntrega':
        this.abaDependenteDisable = false;
        this.abaListaMaterialDisable = false;
        this.abaFormaEntregaDisable = false;
        this.abaEnderecoEntregaDisable = false;
        break;
      case 'formaPagamento':
        this.abaDependenteDisable = false;
        this.abaListaMaterialDisable = false;
        this.abaFormaEntregaDisable = false;
        this.abaEnderecoEntregaDisable = false;
        this.abaFormaPagamentoDisable = false;
        break;
      case 'finalizacao':
        this.abaDependenteDisable = false;
        this.abaListaMaterialDisable = false;
        this.abaFormaEntregaDisable = false;
        this.abaEnderecoEntregaDisable = false;
        this.abaFormaPagamentoDisable = false;
        this.abaFinalizacaoDisable = false;
        break;

      default:
        this.abaDependenteDisable = false;
        break;
    }
  }
}
